<div class="d-flex justify-content-center align-items-center h-100 w-100"
  [class.solid-bg]="solidBackground"
>
  <h2>
    <sof-spinner-icon class="st-text-theme-primary"></sof-spinner-icon>
    <span [vxWatch]="busyModel.message" id="message" class="text-muted ms-2">{{busyModel.message.value}}</span>
  </h2>
</div>
